import { render, staticRenderFns } from "./ServiceSummaryCard.vue?vue&type=template&id=60ddd43f&scoped=true"
import script from "./ServiceSummaryCard.vue?vue&type=script&lang=js"
export * from "./ServiceSummaryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ddd43f",
  null
  
)

export default component.exports